export default function GlbThumbnail({ size = 70, active = false, poster }) {
  return (
    <div
      style={{
        width: "100%",
        height: size,
        minHeight: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: active ? "#e6f4ff" : "#f2f3f7",
        border: active ? "2px solid #1677ff" : "1px solid #d9d9d9",
        borderRadius: 5,
        fontSize: 12,
        fontWeight: 600,
        color: "#1677ff",
        overflow: "hidden",
      }}
    >
      {poster ? (
        <img
          src={poster}
          alt="3D product preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      ) : (
        "3D"
      )}
    </div>
  );
}
